import {API} from "./API";
import {Category} from "../models/Category";

export class CategoriesAPI extends API<Category> {

	constructor () {
		super("serviceCategories");
    }
}
